<template>
  <div 
    id="modal-contact" 
    :class="{'active': active, 'is-active': active}"
    class="ec-modal ec-contact-modal is-fullscreen"
    @click.self="closeModal">
    <div class="ec-modal-main is-transparent animated fadeIn">
      <contact 
        ref="contactModal"
        :scope="scope" 
        :bound-to-calculation="boundToCalculation"
        :in-modal="true" />
    </div>
  </div>
</template>
<script>
import Modal  from './Modal.mixin.vue'

export default {
    el: "#modal-contact",
    name: "ModalContact",
    mixins: [ Modal ],
    data: function() {
        return {
            scope: 'front-page2',
            boundToCalculation: null
        }
    },
    created() {
        this.$event.$on('call-contact-modal', (payload) => {
            if(payload) {
                if(payload.scope) {
                    this.scope = payload.scope
                } else {
                    this.scope = "front-page"
                }

                if(payload.boundToCalculation) {
                    this.boundToCalculation = payload.boundToCalculation
                } else {
                    this.boundToCalculation = null
                }
            }
            
            this.active = true
        })
    }
}
</script>

